export const events = {
  pharmacy: {
    addToCart: { action: 'pharmacy.addToCart' },
    applyForWholesaler: { action: 'pharmacy.applyForWholesaler' },
    placeOrder: { action: 'pharmacy.placeOrder' },
    acceptOffer: { action: 'pharmacy.acceptOffer' },
    cancelOffer: { action: 'pharmacy.cancelOffer' },
    requestCreditLimit: { action: 'pharmacy.requestCreditLimit' },
    payInvoice: { action: 'pharmacy.payInvoice' },
    makeOffer: { action: 'pharmacy.makeOffer' },
    searchProduct: { action: 'pharmacy.searchProduct' }
  }
}

class UmamiHelper {
  init() {}

  trackPageview() {}

  identify(sessionData) {
    try {
      if (typeof window !== 'undefined' && window.umami) {
        window.umami.identify(sessionData)
      }
    } catch (e) {
      // silently ignore — analytics must never break app functionality
    }
  }

  trackEvent(event, props) {
    try {
      if (typeof window !== 'undefined' && window.umami) {
        window.umami.track(event.action, props)
      }
    } catch (e) {
      // silently ignore — analytics must never break app functionality
    }
  }
}

const umami = new UmamiHelper()

export default umami
